// use the table supplied by Bailey to calculate flight hour fractions
import dayjs from "dayjs";
import Big from "big.js";
import { Maybe, Ticket, TicketLocation } from "./avroGraphql";
import { BigOrZeroIfInvalid, DefinitelyAnArray, isValidTimeString } from "./HelperMethods";

// this is a bit cheesy but oh well... find the count of items < your minutes and multiply count by 0.1 to get the result
const TIME_TABLE = [2, 8, 14, 20, 26, 32, 38, 44, 50, 56];

export default class TimeCalculator {
    static getDifferenceInHours(up_time: string | undefined, down_time: string | undefined): number {
        const up = dayjs(up_time);
        const down = dayjs(down_time);
        if (!isValidTimeString(up_time ?? "") || !isValidTimeString(down_time ?? "")) {
            return 0;
        }

        const differenceInMinutes = new Big(down.diff(up, "minute"));
        const leftoverMinutes = differenceInMinutes.mod(60);
        const exceededBoundaryCount = TIME_TABLE.filter((boundary) => boundary < leftoverMinutes.toNumber()).length;
        const fractionalHour = new Big(exceededBoundaryCount).div(10);
        const hours = differenceInMinutes.minus(leftoverMinutes).div(60);

        return hours.plus(fractionalHour).toNumber();
    }

    static getFormatted(timeString: string | undefined): string {
        if (!isValidTimeString(timeString ?? "")) {
            return "--:--";
        }

        const time = dayjs(timeString);

        return `${time.hour()}:${time.minute() < 10 ? "0" : ""}${time.minute()}`;
    }

    static getTotalFlightTimeFormatted(ticket: Ticket | undefined): string {
        return this.getTotalFlightTime(ticket).toFixed(1);
    }

    static getTotalFlightTime(ticket: Ticket | undefined): Big {
        if (!ticket) {
            return new Big(0);
        } else {
            return this.calculateLegFlightHours(DefinitelyAnArray(ticket.Locations));
        }
    }

    private static calculateLegFlightHours(rawList: Maybe<Array<Maybe<TicketLocation>>> | undefined): Big {
        const locations = DefinitelyAnArray(rawList);

        return (
            locations.reduce((total, leg) => {
                const bigHours = BigOrZeroIfInvalid(leg.hours);
                return total.add(bigHours);
            }, new Big(0)) ?? new Big(0)
        );
    }
}

export function UpDownTimeOnEachLeg(ticket: Ticket): boolean {
    return ticket.up_down_required !== 0;
}
